import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import { PublicRouteWithLayout, PrivateRouteWithLayout } from "./components";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";
import {
  publicSignIn as publicLoginPage,
  ServiceArea as serviceAreaComponent,
  addService as AddServiceComponent,
  NotFound as NotFoundPage,
  editservices as Editservicecomponent,
  Itemstable as Itemcomponent,
  Additems as Additemcomponent,
  edititem as Edititemcomponent,
  extraitems as Extraitemcomponent,
  editextraitem as Editextraitemcomponent,
  Addextraitems as Addextraitemcomponent,
  Movesize as Movesizecomponent,
  Addmovesize as Addmovesizecomponent,
  Editmovesize as Editmovesizecomponent,
  Company_List as CompanyListComponent,
  Forman as Formancomponent,
  Customer as Customercomponent,
  Dashboard as Dashboardcomponent,
  Request as Requestcomponent,
  RequestDetail as Requestdetailcomponent,
  CustomerDetail as CustomerDetailComponent,
  Truck as Truckcomponent,
  CompanyTransactions,
  CustomerTransactions,
  Dashboard,
  Settings,
  EvomTransactions,
  AllTransactions,
  CompanyDetail,
  PhoneErrorLogs,
  WishlistTable,
  ListPlans,
  AddPlan,
  EditPlan,
  ListDocument,
  AddDocument,
  EditDocument,
  ListEmailTemplates,
  EditEmailTemplate,
  AddAddress,
  EditAddress,
  EditRequestExtraItems,
  EditRequestItems,
} from "./pages";

const Routes = () => {
  return (
    <Switch>
      <Redirect exact from="/" to="admin" />
      <PublicRouteWithLayout
        component={publicLoginPage}
        exact
        layout={MainLayout}
        path="/login"
      />

      <PrivateRouteWithLayout
        component={AdminRoutes}
        layout={MinimalLayout}
        path="/admin"
      />

      <PublicRouteWithLayout
        layout={MainLayout}
        component={NotFoundPage}
        exact={false}
        path="/"
      />
    </Switch>
  );
};

function AdminRoutes() {
  return (
    <>
      <Switch>
        {/******************************* Dashboard Route ****************************/}

        <Route exact path="/admin" component={Dashboard} />

        {/******************************* Service Area Routes ****************************/}

        <Route
          component={serviceAreaComponent}
          exact
          path="/admin/service-area"
        />
        <Route
          component={Editservicecomponent}
          exact
          path="/admin/edit-service/:id"
        />
        <Route
          component={AddServiceComponent}
          exact
          path="/admin/add-service"
        />

        {/******************************* Wishlist Area Routes ****************************/}

        <Route component={WishlistTable} exact path="/admin/wishlist-area" />

        {/******************************* Extra Items Routes****************************/}

        <Route component={Extraitemcomponent} exact path="/admin/extra-items" />
        <Route
          component={Editextraitemcomponent}
          exact
          path="/admin/edit-extra-items/:id"
        />
        <Route
          component={Addextraitemcomponent}
          exact
          path="/admin/add-extra-items"
        />

        {/******************************* Items Routes ****************************/}

        <Route component={Itemcomponent} exact path="/admin/items" />
        <Route component={Additemcomponent} exact path="/admin/add-items" />
        <Route
          component={Edititemcomponent}
          exact
          path="/admin/edit-item/:id"
        />

        {/******************************* Move-Size Routes ****************************/}

        <Route component={Movesizecomponent} exact path="/admin/move-size" />
        <Route component={Addmovesizecomponent} exact path="/admin/add-move" />
        <Route
          component={Editmovesizecomponent}
          exact
          path="/admin/edit-move/:id"
        />
        {/******************************* EVOM transaction ****************************/}

        <Route
          component={EvomTransactions}
          exact
          path="/admin/lams-transactions"
        />

        {/******************************* EVOM transaction ****************************/}

        <Route
          component={AllTransactions}
          exact
          path="/admin/all-transactions"
        />

        {/******************************* Company transaction ****************************/}
        {/******************************* Companies Routes ****************************/}
        {/******************************* Foreman Routes ****************************/}
        {/******************************* Trcuk Routes ****************************/}
        <Route
          component={CompanyListComponent}
          exact
          path="/admin/company-list"
        />

        <Route
          component={CompanyDetail}
          exact
          path="/admin/company-list/company-details"
        />

        <Route
          component={Formancomponent}
          exact
          path="/admin/company-list/foremans"
        />
        <Route
          component={Truckcomponent}
          exact
          path="/admin/company-list/trucks"
        />
        <Route
          component={CompanyTransactions}
          exact
          path="/admin/company-list/transactions"
        />

        {/******************************* Request Routes ****************************/}

        <Route component={Requestcomponent} exact path="/admin/request" />

        <Route
          component={Requestdetailcomponent}
          exact
          path="/admin/request/details/:id"
        />

        <Route
          exact
          path="/admin/request/edit-extra-items/:requestId"
          component={EditRequestExtraItems}
        />

        <Route
          exact
          path="/admin/request/edit-items/:requestId"
          component={EditRequestItems}
        />

        <Route
          component={AddAddress}
          exact
          path="/admin/request/add-address/:id"
        />

        <Route
          component={EditAddress}
          exact
          path="/admin/request/edit-address/:requestId/:addressId"
        />

        {/******************************* Documents Routes ****************************/}
        <Route component={ListDocument} exact path="/admin/documents" />
        <Route
          component={AddDocument}
          exact
          path="/admin/documents/add-document"
        />
        <Route
          component={EditDocument}
          exact
          path="/admin/documents/edit-document/:id"
        />

        {/******************************* Email Templates Routes ****************************/}

        <Route
          component={ListEmailTemplates}
          exact
          path="/admin/email-templates"
        />
        <Route
          component={EditEmailTemplate}
          exact
          path="/admin/email-templates/email-template/:id"
        />

        {/******************************* Customer Routes ****************************/}
        <Route
          component={Customercomponent}
          exact
          path="/admin/customer-list"
        />
        <Route
          component={CustomerTransactions}
          exact
          path="/admin/customer-list/transactions"
        />
        <Route
          component={CustomerDetailComponent}
          exact
          path="/admin/customer-list/customer-details"
        />

        {/*******************************  Phone Error Logs ****************************/}

        <Route
          component={PhoneErrorLogs}
          exact
          path="/admin/phone-error-logs"
        />

        {/*******************************  subscription-plans ****************************/}

        <Route component={ListPlans} exact path="/admin/subscription-plans" />
        <Route
          component={AddPlan}
          exact
          path="/admin/subscription-plans/add-subscription-plans"
        />
        <Route
          component={EditPlan}
          exact
          path="/admin/subscription-plans/edit-subscription-plans/:id"
        />

        {/******************************* Page Not Found ****************************/}

        <Route component={Settings} exact path="/admin/settings" />

        {/******************************* Page Not Found ****************************/}

        <Route component={NotFoundPage} exact={false} path="/" />
      </Switch>
    </>
  );
}

export default Routes;
